// extracted by css-extract-rspack-plugin
export default {"searchIconWrapper":"_fb77cccd"};